import React from "react";
import { industries } from "../mock/mock";

const Industries = () => {
  const row = [...industries, ...industries];
  return (
    <section id="industries" className="bg-[#0A0A0A] text-[#F4F1EA] py-20 overflow-hidden border-b-2 border-[#0A0A0A]">
      <div className="container-x mb-12">
        <p className="eyebrow text-[#F4F1EA]/50">/ Industries</p>
        <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95] max-w-3xl">
          Industry-Focused Solutions. <span className="hl-invert">Real Impact</span>
        </h2>
      </div>

      <div className="marquee-pause overflow-hidden border-y-2 border-[#F4F1EA]/25 py-2">
        <div className="flex items-center w-max animate-marquee">
          {row.map((ind, i) => (
            <span key={i} className="display text-3xl md:text-5xl font-extrabold uppercase px-8 py-3 whitespace-nowrap flex items-center gap-8">
              {ind} <span className="text-2xl" style={{ color: "var(--accent)" }}>∞</span>
            </span>
          ))}
        </div>
      </div>

      <div className="marquee-pause overflow-hidden py-2 mt-2">
        <div className="flex items-center w-max animate-marquee-slow" style={{ transform: "translateX(-25%)" }}>
          {[...row].reverse().map((ind, i) => (
            <span key={i} className="display text-3xl md:text-5xl font-extrabold uppercase px-8 py-3 whitespace-nowrap flex items-center gap-8 text-transparent" style={{ WebkitTextStroke: "1.5px #F4F1EA" }}>
              {ind} <span className="text-2xl" style={{ WebkitTextStroke: "0", color: "#F4F1EA33" }}>∞</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
